import RequiresEmailConfirmation from 'components/pages/RequiresEmailConfirmation/RequiresEmailConfirmation';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('registration-login');
export default buildPage(RequiresEmailConfirmation, {
  metaData: {
    title: 'Check your messages',
    description:
      "We've sent a message to you. Open it up and click on any button to verify your account.",
  },
  loggedInRedirect: '/dashboard',
});
